import { applyMiddleware, createStore } from 'redux';
import createSagaMiddleware from 'redux-saga';
// import logger from 'redux-logger';
import reducers from '../reducers';
import sagas from '../sagas';

let store;
const sagaMiddleware = createSagaMiddleware();
const middleware = applyMiddleware(
  sagaMiddleware,
  // logger()
);

export const createRedux = initialState => {
  store = createStore(reducers, initialState, middleware);
  sagaMiddleware.run(sagas);
  return store;
}

export const getStore = () => store;



// WEBPACK FOOTER //
// ./src/store/index.js